<template>
  <div>
    <!-- 面包屑导航 -->
  <div class="flexc-cen-x fixed">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>能力等级</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select> -->
  </div>
    <!-- 搜索筛选 -->
  <el-form :inline="true" :model="formInline" class="flex-r-x" style="padding-top:30px">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="mini" type="primary" v-if="q1 == true" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

  </el-form>
    <!--列表-->
      <div style="height:65vh;overflow:auto;">
    <el-table  :data="tableData" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">

        <el-table-column  prop="CapacityName" label="能力名称">
        </el-table-column>

        <el-table-column  prop="ProjectName" label="关联课程" align="center" >
        </el-table-column>


      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" v-if="q2 == true">编辑</el-button>
          <!-- <el-button v-if="scope.row.Isdisable == 0" type="warning" plain size="mini" @click="handlejie(scope.row)">禁用</el-button>
           <el-button v-if="scope.row.Isdisable == 1" type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="setLimits(scope.row)" >权限配置</el-button>
   -->
          <el-button size="mini" type="info" @click="deleteUser(scope.row)" v-if="q3 == true">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      </div>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
         <el-form-item label="能力名称:" prop="CapacityName">
          <el-input size="small" v-model="editForm.CapacityName" auto-complete="off" placeholder="请输入能力名称"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="支持课程：" prop="ProjectIDs">
              <span @click="addCourseIDs" class="set-link">选择课程</span>  
                              <br> 
               <span >{{editForm.ProjectName}}</span> 
         </el-form-item>
        
        
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
        
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>

<el-dialog
      title="选择课程"
       :visible.sync="dialoglaoshiVisible"
      width="40%"
        >
            <el-table :data="courseList" ref="docTable" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionChange" >
              <el-table-column type="selection" width="55" > </el-table-column>
                 <el-table-column label="课程姓名" prop="ProjectName" ></el-table-column>
                <el-table-column label="门店" prop="StoresName" ></el-table-column>

             </el-table> 
             <!--
              <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                     :current-page.sync="currentPage1"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit1"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count1">
                    </el-pagination>
                    </div>  -->
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhao">确 定</el-button>
        <el-button @click="dialoglaoshiVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      DianList:[],
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'listsub',
          label: 'Name'
        },
       direction: "ltr",
      passShow:false,
      dialoglaoshiVisible:false,
      limit1: 10,
      count1:0,
      currentPage1:1,
      offset1:1,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      courseList:[],
      multipleSelection:[],
      Pwd:'',
      RoleID:'',
      ProjectIDs:'',
      SelectStoresID:localStorage.getItem("StoresID"),
      editForm: {
        ProjectIDs:'',
        CapacityName:'',
        ProjectName:'',
      },
      // rules表单验证
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      rules: {
        CapacityName: [{ required: true, message: '请输入能力名称', trigger: 'blur' }],
 
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
      if(localStorage.getItem('isAdmin') == 1){

          this.q1 = true
          this.q2 = true
          this.q3 = true

      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 862)
            this.q1  =true
            if(items == 863)
            this.q2 = true
            if(items == 864)
            this.q3 = true

      })
    //    this.getType()
    this.getList()
    this.getDianList()
    //   this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersCapacitylID:row.ID,
        
        }
        var that = this
        this.ajax('delMembersCapacity.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑能力'
       
              this.editForm = row
    
          } else {
              this.title = '添加能力'
                this.editForm = {
                    ProjectIDs:'',
                    CapacityName:'',
                    ProjectName:'',
                }
          }
          this.editFormVisible = true
    },
    addCourseIDs(){
       this.ProjectIDs =  this.editForm.ProjectIDs;
        this.getListProject();
    },handleSizeChange1(val){
        this.limit1 = val;
        this.currentPage1 = 1;
        this.offset1 = 1;
        this.getListProject();
       },
      // 当前页变动时候触发的事件
      handleCurrentChange1(val) {
        this.currentPage1 = val;
        this.offset1 =val;
        this.getListProject()
       },getListProject(){

       var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:10000,
       }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListProjectNL.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.dialoglaoshiVisible = true
                that.courseList = res.data
                that.count1 = res.allcount

                 that.toggleSelection(that.courseList);

                 loading.close();
          } 

      })
  
    },toggleSelection (rows) {
                 let arr = []
                 let allPermission = this.ProjectIDs.split(',');
 
                 rows.forEach(item => {
                    allPermission.forEach(element =>{
                 if (element === item.ID) {
                       arr.push(item)
                    }
                   })
                })
 
             if (arr) {
                   this.$nextTick(() => {
               arr.forEach(row => {
                 this.$refs.docTable.toggleRowSelection(row,true);
              });
              })
                } else {
                 this.$refs.docTable.clearSelection()
                }
                },handleSelectionChange(val){
                this.multipleSelection = val;

            },doxuanhao(){
                let arr = [];
                let arrname = [];
                this.multipleSelection.forEach(element => {
                    arr.push(element.ID);
                    arrname.push(element.ProjectName);
                });
                

                let uniqueArr = Array.from(new Set(arr));
                let uniquenameArr = Array.from(new Set(arrname));

                 if(arr.length>0){
 
                         
                              this.editForm.ProjectIDs = uniqueArr.join();
                             this.editForm.ProjectName= uniquenameArr.join();

                        
                }else{
                    
                  this.$message({
                                    type: "error",
                                    message: "请选择课程",duration:2000,
                                  });
                            return;
                        //  this.ruleForm.ProjectIDs="";
                        //  this.ruleForm.ProjectName= "";
 
                    
                }
                 
                        this.dialoglaoshiVisible =false;
                    

                    
             
                 
            },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
        //   pages:this.formInline.page,
        //   psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListMembersCapacity.aspx ',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title == '添加能力'){
                this.ajax('addMembersCapacity.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.MembersCapacityID =  this.editForm.ID
                 this.ajax('editMembersCapacity.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.set-link {
    display: inline-block;
    margin-left: 8px;
    color: #409EFF;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/vipCapacity.vue